import React, { Component } from 'react'
import {
    MDBContainer,
    MDBBtn,
    MDBModal,
    MDBModalBody,
    MDBModalHeader,
    MDBModalFooter
} from 'mdbreact';
import { MDBRow, MDBCol, MDBIcon } from "mdbreact";
import { Alert, Form, Input, Button, Select, Icon, message, Tag, Badge, Tooltip , Divider } from 'antd';
import { api } from '../../api';
import Swal from 'sweetalert2'

export default class Modaldiver extends Component {

    constructor(props) {
        super(props);
        this.state = {
            modal: false,
            loading: false,
            namebanner: '',
            fileupload: '',

            namecar:'',
            namedriver:'',
            id_user:'',
            teldriver:'',
            getadmin:[],

            namediver:'',
            username:'',
            password:'',

        }

        this.handleSubmit = this.handleSubmit.bind(this);
        this.toggle = this.toggle.bind(this);
        this.handleChangefile = this.handleChangefile.bind(this);
        this.onTextChange = this.onTextChange.bind(this);
        this.getadmin = this.getadmin.bind(this);
        this.onBlur = this.onBlur.bind(this);
        this.onFocus = this.onFocus.bind(this);
        this.handleChange = this.handleChange.bind(this);
       
    }
    onTextChange = (e) => {
        this.setState({ [e.target.name]: e.target.value })
    }

    handleChangefile(event) {    this.setState({fileupload: event.target.files[0]});  }

    toggle = () => {
        this.setState({
            modal: !this.state.modal
        });
        this.getadmin();
    }

    getadmin() {
        this.setState({ loading: true})
        setTimeout(() => {
           //ภายใน
           api.get('selectadminshow.php')
           .then(res => {
             console.log(res);
           //  this.setState({ bankname: res.data, loading: false })
             this.setState({ getadmin: res.data,loading:false})
           }) 
         }, 0);
      }

     
      
       onBlur() {
        console.log('blur');
      }
      
       onFocus() {
        console.log('focus');
      }

      handleChange(event) {    this.setState({id_user: event});  }

    //selectadminshow

    handleSubmit(e) {
        e.preventDefault();
        // alert('A name was submitted: ' + this.state.value);
     //   const date = new Date().toISOString().slice(0, 10)
       setTimeout(() => {
    
          const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูล
          datafrm.append("namediver", this.state.namediver);
          datafrm.append("username", this.state.username);
          datafrm.append("password", this.state.password);
       
          //datafrm.append("id_workorder", this.state.id_workorder);
        
          api.post("insertdiver.php",datafrm,{
                headers: {
                    'content-type': 'multipart/form-data'
                }
            })
    
       .then(res => {
        if (res.status=== 200) {
            Swal.fire({
                title: 'บันทึกข้อมูลคนขับสำเร็จ',
                icon: 'success',
              // showCancelButton: true,
                confirmButtonText: 'ตกลง',
              // cancelButtonText: 'No, keep it'
              }).then((result) => {
                this.setState({
                    namecar: '',
                    namedriver: '',
                    teldriver: '',
                });
                this.toggle();  
                this.props.getdiver();
            //  this.getworklist();
              //  this.props.getbanner();
              })
        }else{
          message.error("อัพโหลไฟล์ไม่สำเร็จ!")
        }
    
      })
    
    
    }, 2000);
    
    //window.location.href = '/adminfaculty'
    //this.props.updateat();
    //this.getExpert()
     
      }

    render() {
   // console.log(this.state.namework)
 //   console.log(this.state.fileupload)
 const { Option } = Select;
        return (
            <MDBContainer>
                <MDBBtn color="pink" onClick={this.toggle}>เพิ่มข้อมูลคนขับ</MDBBtn>
                <MDBModal isOpen={this.state.modal} toggle={this.toggle}>
                    <MDBModalHeader toggle={this.toggle}><MDBIcon icon="car-side" /> เพิ่มข้อมูลคนขับ</MDBModalHeader>
                    <MDBModalBody>
                        <form onSubmit={this.handleSubmit}>
                            <div className="mb-2 text-left">
                                <label className="font-weight-bold"><MDBIcon icon="bible" /> ชื่อ - สกุล </label>
                                <input className="form-control" onChange={this.onTextChange} name="namediver"
                                    value={this.state.namediver} placeholder="ชื่อ - สกุล" required />
                            </div>
                            <div className="mb-2 text-left">
                                <label className="font-weight-bold"><MDBIcon icon="bible" /> username</label>
                                <input className="form-control" onChange={this.onTextChange} name="username"
                                    value={this.state.username} placeholder="username" required />
                            </div>
                       
                            <div className="mb-2 text-left">
                                <label className="font-weight-bold"><MDBIcon icon="bible" /> password</label>
                                <input className="form-control"  onChange={this.onTextChange} name="password"
                                    value={this.state.password} placeholder="password" required />
                            </div>
                           
                            {/* <Divider orientation="left" plain>
                            Left Text
                            </Divider> */}
                            {/* {this.state.filedesing_workorder == '' && this.state.filedesing_workorder == null ? <></> : <>
                                <MDBRow>
                                    <MDBCol>
                                        <img src={`https://lookmaenamping.com/sorlalumbackend/uploadsdesing/${this.state.filedesing_workorder}`} className="rounded mx-auto d-block " width="500" alt="aligment" />
                                    </MDBCol>
                                </MDBRow>
                            </>} */}


                            {/* <p className="purple-text text-center">ตรวจสอบข้อมูลว่าถูกต้องครบถ้วน</p> */}
                            <div className="mt-3 text-center" >
                                <MDBBtn type="submit" color="deep-purple" className="text-center"> <MDBIcon far icon="save" /> บันทึก</MDBBtn>
                                <MDBBtn color="secondary" onClick={this.toggle}>ปิด</MDBBtn>
                            </div>


                        </form>
                    </MDBModalBody>
                    <MDBModalFooter>
                        {/* <MDBBtn color="secondary" onClick={this.toggle}>ปิด</MDBBtn> */}
                        {/* <MDBBtn color="primary">Save changes</MDBBtn> */}
                    </MDBModalFooter>
                </MDBModal>
            </MDBContainer>
        )
    }
}
